import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
import type { Product } from "@/lib/types";

/** Active products a customer can add to a booking (sold-out ones included). */
export function useProducts() {
  return useQuery({
    queryKey: ['/products'],
    queryFn: async (): Promise<Product[]> => {
      const res = await apiClient.get('/products');
      if (!res.ok) throw new Error("Failed to fetch products");
      return res.json();
    },
  });
}
